import React from "react";
// Componente que renderiza los options de las horas de los centros
const TimeOptions = ({ date }) => {
    console.log('date', new Date(date).getDay())
    let from = 8;
    let to = 20;

    let options = [];
    if (new Date(date).getDay() === 6) {
        from = 9;
        to = 13;
        options.push(
            <option key="no-value" value=''>(Selecciona una opción)</option>
        )
    }

    for (let i = from; i < to; i++) {
        options.push(
            <option key={i} value={i < 10 ? `0${i}:00` : `${i}:00`}>{i < 10 ? `0${i}:00` : `${i}:00`}</option>
        )
        options.push(
            <option key={i + 0.5} value={i < 10 ? `0${i}:30` : `${i}:30`}>{i < 10 ? `0${i}:30` : `${i}:30`}</option>
        )
    }

    return options;
} 

export default TimeOptions;


// WEBPACK FOOTER //
// ./src/components/TimeOptions/index.jsx